import React, { useEffect, useState } from "react";
import Breadcrumb from './Breadcrumb';
import Productslider from './Productslider';
import axios from 'axios'
import { Link } from 'react-router-dom'

function Uploadimagecontent() {

    const [file, setFile] = useState(null);
    const [logo, setLogo] = useState('');
    const [title, setTitle] = useState('');
    const [headerColor, setHeaderColor] = useState('#191F38');
    const [footerColor, setFooterColor] = useState('#DAD7B6');
    const [headerTextColor, setHeaderTextColor] = useState('#ffffff');
    const [footerTextColor, setFooterTextColor] = useState('#000000');

    useEffect(() => {
      loadLogo();
   }, []);
    

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
 
  const loadLogo=()=>{
    fetch("https://foresttacafemenuapi.deepsciencetech.com/index.php/Api/logo", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => res.json())
        .then((result) => {
          //console.log(result);
          if (result.data != "") {
            const data = result.data;
            setLogo(data);
            setTitle(data.title);
            if (data.header_color) setHeaderColor(data.header_color);
            if (data.footer_color) setFooterColor(data.footer_color);
            if (data.header_text_color) setHeaderTextColor(data.header_text_color);
            if (data.footer_text_color) setFooterTextColor(data.footer_text_color);
          }
        })
      .catch((err) => {
        console.log(err.message);
      });
  }

  const handleSubmit = async(event) => {
    event.preventDefault();

    try {
        const formDataObj = new FormData();
        formDataObj.append('file', file);
        formDataObj.append('title', title);
        formDataObj.append('header_color', headerColor);
        formDataObj.append('footer_color', footerColor);
        formDataObj.append('header_text_color', headerTextColor);
        formDataObj.append('footer_text_color', footerTextColor);
  
        const response = await axios.post('https://foresttacafemenuapi.deepsciencetech.com/index.php/Api/updatelogo', formDataObj, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        //window.location.href = '/menu-grid';
        //if(file!=null){ 
           alert("Data updated successfully");
        //}
      } catch (error) {
        console.error('Error uploading file:', error);
      }

  };

      const handleInputChange = (event) => {
        setTitle(event.target.value);
      };

        return (
            <div className="ms-content-wrapper">
                <div className="row">
                    <div className="col-md-12" >
                     <nav aria-label="breadcrumb">
                        <ol className="breadcrumb pl-0">
                            <li className="breadcrumb-item"><Link to="/"><i className="material-icons">home</i> Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Update Theme Details</li>
                        </ol>
                    </nav>
                      
                    </div>
                    <div className="col-xl-12 col-md-12">
                        <div className="ms-panel ms-panel-fh">
                            <div className="ms-panel-header">
                                <h6>Update Theme Details</h6>
                            </div>
                            <div className="ms-panel-body">
                                <form className="needs-validation clearfix"  onSubmit={handleSubmit} key="addform">
                                    <div className="form-row">
                           
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="title">Title</label>
                                            <div className="input-group">
                                                <input type="text" className="form-control" id="title" placeholder="title" required name="title" defaultValue={title} onChange={handleInputChange}/>
                                                <div className="invalid-feedback">
                                                    Title
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="validationCustom12">Upload Logo</label>
                                            <div className="custom-file">
                                                <input type="file"  name="image" id="validatedCustomFile" onChange={handleFileChange} accept="image/*"/>
                                            </div>
                                            <img className="mt-3" src={logo.image} style={{height: "100px"}}/>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label>Header Background Color</label>
                                            <div className="d-flex align-items-center">
                                                <input type="color" value={headerColor} onChange={e => setHeaderColor(e.target.value)} style={{width:'50px', height:'40px', marginRight:'10px', border:'1px solid #ccc', borderRadius:'4px', cursor:'pointer'}}/>
                                                <input type="text" className="form-control" value={headerColor} onChange={e => setHeaderColor(e.target.value)} style={{maxWidth:'120px'}}/>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label>Header Text Color</label>
                                            <div className="d-flex align-items-center">
                                                <input type="color" value={headerTextColor} onChange={e => setHeaderTextColor(e.target.value)} style={{width:'50px', height:'40px', marginRight:'10px', border:'1px solid #ccc', borderRadius:'4px', cursor:'pointer'}}/>
                                                <input type="text" className="form-control" value={headerTextColor} onChange={e => setHeaderTextColor(e.target.value)} style={{maxWidth:'120px'}}/>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label>Footer Background Color</label>
                                            <div className="d-flex align-items-center">
                                                <input type="color" value={footerColor} onChange={e => setFooterColor(e.target.value)} style={{width:'50px', height:'40px', marginRight:'10px', border:'1px solid #ccc', borderRadius:'4px', cursor:'pointer'}}/>
                                                <input type="text" className="form-control" value={footerColor} onChange={e => setFooterColor(e.target.value)} style={{maxWidth:'120px'}}/>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label>Footer Text Color</label>
                                            <div className="d-flex align-items-center">
                                                <input type="color" value={footerTextColor} onChange={e => setFooterTextColor(e.target.value)} style={{width:'50px', height:'40px', marginRight:'10px', border:'1px solid #ccc', borderRadius:'4px', cursor:'pointer'}}/>
                                                <input type="text" className="form-control" value={footerTextColor} onChange={e => setFooterTextColor(e.target.value)} style={{maxWidth:'120px'}}/>
                                            </div>
                                        </div>
                                        
                                        
                                        <div className="ms-panel-header new">
                                          <button className="btn btn-primary d-block" type="submit" >Save</button>
                                        </div>
                                     
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        );

}

export default Uploadimagecontent;